/**
 * Create a random string. Extract because it was used a lot of times.
 *
 * @param {Number} [length=10] length
 * @returns {String}
 */
App.namespace('shared.generateRandomId', function (length) {
    return function () {
        length = length || 10;

        return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
    };
});